import React, { useContext } from 'react'

import { EngravingContext } from 'components/buy/Engraving/EngravingContext'
import Front from 'components/buy/Engraving/Front'
import Back from 'components/buy/Engraving/Back'
import Box from 'components/buy/Engraving/Box'
import Summary from 'components/buy/Engraving/Summary'

const Engraving = () => {
  return <InnerEngraving />
}

export default Engraving

const InnerEngraving = () => {
  const { engraving } = useContext(EngravingContext)

  if (!engraving.front.proceeded) return <Front />
  if (!engraving.back.proceeded) return <Back />
  if (!engraving.box.proceeded) return <Box />
  if (engraving.front.proceeded && engraving.back.proceeded && engraving.box.proceeded) return <Summary />
}
